<template>
  <div v-if="compact" class="tw-flex tw-aspect-square tw-w-full tw-flex-col tw-items-center tw-justify-center tw-space-y-1 tw-p-2 tw-text-center">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
      class="tw-h-6 tw-w-6 tw-flex-shrink-0 tw-text-gray-400"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="1.5"
        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
      />
    </svg>
    <span class="tw-text-xs tw-font-medium tw-leading-tight tw-text-primary-600">
      {{ $t('app.upload_a_file') }}
    </span>
    <span
      v-if="!doesNotHaveSize"
      class="tw-text-[10px] tw-leading-tight tw-text-gray-400"
    >
      {{ width }}x{{ height }}
    </span>
  </div>
  <div v-else class="">
    <div
      class="tw-mx-auto tw-flex tw-max-w-lg tw-justify-center tw-px-6 tw-pt-5 tw-pb-6"
    >
      <div class="tw-space-y-1 tw-text-center">
        <svg
          v-if="!doesNotHaveSize"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          class="tw-mx-auto tw-h-12 tw-w-12 tw-text-gray-400"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1"
            d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
          />
        </svg>
        <div
          class="tw-flex tw-justify-center tw-text-center tw-text-sm tw-text-gray-600"
        >
          <div class="tw-flex tw-flex-wrap">
            <label
              for="file-upload"
              class="focus-within:outline-none tw-relative tw-mx-auto tw-cursor-pointer tw-rounded-md tw-font-medium tw-text-primary-600 focus-within:tw-ring-2 focus-within:tw-ring-primary-500 focus-within:tw-ring-offset-2 hover:tw-text-primary-500"
            >
              <span>{{ $t('app.upload_a_file') }}</span>
            </label>
            <p class="tw-mb-0 tw-pl-1">{{ $t('app.upload_a_file_drag') }}</p>
          </div>
        </div>
        <p v-if="placeholder" class="tw-mb-0 tw-text-sm tw-text-gray-500">
          {{ placeholder }}
        </p>
        <p
          v-else-if="!doesNotHaveSize"
          class="tw-mb-0 tw-text-xs tw-text-gray-500"
        >
          <i18n path="app.upload_text" tag="div">
            <template #size>
              <span> {{ width }}x{{ height }} </span>
            </template>
            <template #break>
              <br />
            </template>
          </i18n>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: '',
    },
    // vista reducida, pensada para logos/iconos pequeños donde no entra el texto largo
    compact: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    doesNotHaveSize() {
      return [this.height, this.width].includes(0)
    },
  },
}
</script>

<style></style>
